export const loadImageDimensions = (
  src: string
): Promise<{ naturalWidth: number; naturalHeight: number }> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      resolve({
        naturalWidth: image.naturalWidth,
        naturalHeight: image.naturalHeight,
      })
    }
    image.onerror = () => reject(new Error("Failed to load image"))
    image.src = src
  })
